import { useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { ApiConstant, LangConstant } from "const";
import { ApiUtils, HumpUtils, SystemUtils } from "utils";
import { useRole } from "../index";
import { SERVICE_ID } from "../../const/system.const";

export default function useConferenceList() {
  const { t: getLabel } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const page = searchParams.get("page") || 1;
  const search = searchParams.get("search") || "";

  const [pagination, setPagination] = useState({ total: 1, current: parseInt(page) });
  const [searchInput, setSearchInput] = useState(search);

  const handleChangeSearchInput = event => {
    const newUrlSearchParams = new URLSearchParams(searchParams);
    const searchInputValue = event.target.value;
    newUrlSearchParams.set("page", "1");
    newUrlSearchParams.set("search", searchInputValue);
    history.push(location.pathname + "?" + newUrlSearchParams.toString());
    setPagination(state => ({ ...state, current: 1 }));
    setSearchInput(searchInputValue);
  };

  const handleChangePage = (_, page) => {
    const newUrlSearchParams = new URLSearchParams(searchParams);
    newUrlSearchParams.set("page", page);
    history.push(location.pathname + "?" + newUrlSearchParams.toString());
    setPagination(state => ({ ...state, current: parseInt(page) }));
  };

  const { isServiceAdmin } = useRole();

  const conferenceListQuery = useQuery({
    queryKey: [ApiConstant.REACT_QUERY_KEYS.getServiceConfig, searchInput, pagination.current],
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    queryFn: async () => {
      const payload = [];
      const response = await ApiUtils.createApiWithToken(false).get(
        ApiConstant.GET_SERVER_CONFIG,
        HumpUtils.decamelizeKeys(payload),
      );
      var services = HumpUtils.camelizeKeys(response.data.data.valid_service);
      if (isServiceAdmin) {
        return services.filter(service => [SERVICE_ID.conference, SERVICE_ID.calendar].includes(service.serviceId));
      }
      return services;
    },
    onSuccess: response => {
      setPagination(state => ({ ...state, total: response?.data?.totalPages }));
    },
    onError: error => {
      console.error(error);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    },
  });

  const { refetch } = conferenceListQuery;

  return {
    pagination: pagination,
    searchInput: searchInput,
    conferences: refactorAppList(conferenceListQuery?.data || []),
    handleChangeSearchInput: handleChangeSearchInput,
    handleChangePage: handleChangePage,
    refetchConference: refetch,
  };
}

const refactorAppList = appList => {
  const refactorAppList = appList.map(item => {
    item.config = item.options ? JSON.parse(item.options) : DEFAULT_CONFIG;
    return item;
  });

  return refactorAppList;
};

const DEFAULT_CONFIG = {
  title: "HỆ THỐNG KHAI THÁC THÔNG TIN, TÀI LIỆU",
  subtitle: "",
  title_hidden_f: 1,
  subtitle_hidden_f: 1,
};
